import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(true);

  const applyBrand = (b) => {
    if (!b) return;
    setBrand(b);
    if (b.primary_color) document.documentElement.style.setProperty("--brand-primary", b.primary_color);
    if (b.accent_color) document.documentElement.style.setProperty("--brand-accent", b.accent_color);
    if (b.studio_name) document.title = `${b.studio_name} — CRM`;
  };

  const refreshBrand = async () => {
    try { const r = await api.get("/brand"); applyBrand(r.data); }
    catch (e) { console.warn("brand refresh failed", e); }
  };

  const bootstrap = async () => {
    const t = localStorage.getItem("crm_token");
    if (!t) { setLoading(false); return; }
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
      await refreshBrand();
    } catch (e) {
      localStorage.removeItem("crm_token");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { bootstrap(); }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("crm_token", r.data.token);
    setUser(r.data.user);
    await refreshBrand();
    return r.data.user;
  };

  const register = async (email, name, password) => {
    const r = await api.post("/auth/register", { email, name, password });
    localStorage.setItem("crm_token", r.data.token);
    setUser(r.data.user);
    await refreshBrand();
    return r.data.user;
  };

  const googleAuth = async (session_id) => {
    const r = await api.post("/auth/google", { session_id });
    localStorage.setItem("crm_token", r.data.token);
    setUser(r.data.user);
    await refreshBrand();
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("crm_token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, brand, loading, login, register, googleAuth, logout, refreshBrand, applyBrand }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
